import { useContext } from 'react'
import { getDataContextLocalStorage, getPaymentStateLocalStorage, removeDataContextLocalStorage, removePaymentStateLocalStorage, setDataContextLocalStorage, setPaymentStateLocalStorage } from '../helpers/localStorage'
import { getPinflagApiKey } from '../helpers/utils'
import { usePayment } from './payment/usePayment/usePayment'
import { DataContext } from '../context/DataContext'

// This file is incomplete, some helpers logic might be placed here
export const useLocalStorage = () => {
  const {
    userInfo,
    addressInfo,
    cartData,
    selectedServiceType,
    selectedShippingMethod,
    deliveryInfo,
    discountInfo,
    customerInfo,
    billingInfo,
    ecommerceInfo,
    companyInfo,
    loaderInfo,
    steps,
    currentStep
  } = useContext(DataContext)

  const dataContext = {
    userInfo,
    addressInfo,
    cartData,
    selectedServiceType,
    discountInfo,
    selectedShippingMethod,
    deliveryInfo,
    customerInfo,
    billingInfo,
    ecommerceInfo,
    companyInfo,
    loaderInfo,
    steps,
    currentStep
  }

  const { paymentState } = usePayment()

  const saveDataContext = () => {
    setDataContextLocalStorage(dataContext, getPinflagApiKey())
  }

  const getDataContext = (retries = 0) => {
    // Try to get the data from the localStorage and retry if it fails
    try {
      return getDataContextLocalStorage(getPinflagApiKey())
    } catch (error) {
      if (retries < 3) {
        return getDataContext(retries + 1)
      }
      return null
    }
  }

  const removeDataContext = () => {
    removeDataContextLocalStorage(getPinflagApiKey())
  }

  const savePaymentState = () => {
    setPaymentStateLocalStorage(paymentState, getPinflagApiKey())
  }

  const getPaymentState = (retries = 0) => {
    // Try to get the data from the localStorage and retry if it fails
    try {
      return getPaymentStateLocalStorage(getPinflagApiKey())
    } catch (error) {
      if (retries < 3) {
        return getPaymentState(retries + 1)
      }
      return null
    }
  }

  const removePaymentState = () => {
    removePaymentStateLocalStorage(getPinflagApiKey())
  }

  return {
    saveDataContext,
    getDataContext,
    savePaymentState,
    getPaymentState,
    removeDataContext,
    removePaymentState
  }
}
